import { noop } from 'lodash-es'
import { LuLayers } from 'react-icons/lu'

import { MapEmbedding } from '@/feature/map/components/MapEmbedding'

import { LayerManagerProps } from './LayerManager.types'
import { resolveLayerToggles, toControlledProps, toTasksProps } from './LayerManager.utils'
import { LayerToggle } from './LayerToggle'
import { MapModeLayerToggle } from './MapModeLayerToggle'
import { TasksLayerToggle } from './TasksLayerToggle'
import { TrafficLayerToggle } from './TrafficLayerToggle'
import { VehicleLabelControls } from './VehicleLabelControls'

import styles from './LayerManager.module.css'

const DEFAULT_TOGGLES: LayerManagerProps['toggles'] = {
  satellite: true,
  traffic: true,
  assets: {
    name: 'Assets',
    value: false,
    setValue: noop,
  },
}

export const LayerManager = ({ toggles = DEFAULT_TOGGLES, vehicleLabels }: LayerManagerProps) => {
  return (
    <MapEmbedding
      position={window.google.maps.ControlPosition.RIGHT_TOP}
      className={styles.mapContainer}
    >
      <button
        type="button"
        className={styles.mapButton}
        aria-label="Map layers"
        data-testid="layer-manager-button"
      >
        <LuLayers size="24" />
      </button>
      <div className={styles.layerToggles} data-testid="layer-manager-panel">
        <h4 className={styles.toggleTile}>Map Layers</h4>
        {resolveLayerToggles(toggles).map(({ key, kind, option }) => {
          switch (kind) {
            case 'traffic':
              return <TrafficLayerToggle key={key} {...toControlledProps(option)} />
            case 'satellite':
              return <MapModeLayerToggle key={key} {...toControlledProps(option)} />
            case 'tasks':
              return <TasksLayerToggle key={key} {...toTasksProps(option)} />
            default:
              // `resolveLayerToggles` guarantees an option for generic keys.
              return <LayerToggle key={key} {...option!} testId={`layer-manager-${key}-toggle`} />
          }
        })}
        {vehicleLabels ? <VehicleLabelControls {...vehicleLabels} /> : null}
      </div>
    </MapEmbedding>
  )
}
